import {
    FETCH_LUCKYMONEYS,
    FETCH_WINNERDETAILS
} from '../actions/luckyMoney';


export const initialState = {
    isFetching: true,
    data: null
};

export const luckyMoneys = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_LUCKYMONEYS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_LUCKYMONEYS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const winnerDetails = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_WINNERDETAILS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_WINNERDETAILS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/luckyMoney.js